function autoSelectFirstAvailableOptions() {
  // Hilfsfunktion: Wählt erste verfügbare Option innerhalb einer Gruppe
  function selectFirstAvailable(name) {
    const radios = document.querySelectorAll(`input[name="${name}"]`);
    for (const radio of radios) {
      if (!radio.disabled) {
        const label = document.querySelector(`label[for="${radio.id}"]`);
        if (label) {
          label.click();
          break;
        }
      }
    }
  }

  // Wählt Rahmen und Größe (globo-option-1 & globo-option-2)
  selectFirstAvailable("globo-option-1");
  setTimeout(() => {
    selectFirstAvailable("globo-option-2");
  }, 200); // kurze Verzögerung für DOM-Update
}

// 1. Beim ersten Laden
document.addEventListener("DOMContentLoaded", function () {
  setTimeout(autoSelectFirstAvailableOptions, 500); // Warten bis DOM geladen ist
});

// 2. Beim Wechsel des Materials (globo-option-0)
document.addEventListener("change", function (e) {
  if (e.target.name === "globo-option-0") {
    setTimeout(autoSelectFirstAvailableOptions, 300);
  }
});
